export default "<app-header></app-header>\r\n\r\n<img src=\"../../assets/404.png\">"